'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var dirSharded = require('./dir-sharded.js');

var dirFlat = require('./dir-flat.js');

function flatToShard(_x, _x2, _x3, _x4) {
  return _flatToShard.apply(this, arguments);
}

function _flatToShard() {
  _flatToShard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(child, dir, threshold, options) {
    var newDir, parent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            newDir = dir;

            if (!(dir instanceof dirFlat && dir.directChildrenCount() >= threshold)) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return convertToShard(dir, options);

          case 4:
            newDir = _context.sent;

          case 5:
            parent = newDir.parent;

            if (!parent) {
              _context.next = 14;
              break;
            }

            if (!(newDir !== dir)) {
              _context.next = 13;
              break;
            }

            if (child) {
              child.parent = newDir;
            }

            if (newDir.parentKey) {
              _context.next = 11;
              break;
            }

            throw new Error('No parent key found');

          case 11:
            _context.next = 13;
            return parent.put(newDir.parentKey, newDir);

          case 13:
            return _context.abrupt("return", flatToShard(newDir, parent, threshold, options));

          case 14:
            return _context.abrupt("return", newDir);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _flatToShard.apply(this, arguments);
}

function convertToShard(_x5, _x6) {
  return _convertToShard.apply(this, arguments);
}

function _convertToShard() {
  _convertToShard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(oldDir, options) {
    var newDir, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, key, child;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            newDir = new dirSharded({
              root: oldDir.root,
              dir: true,
              parent: oldDir.parent,
              parentKey: oldDir.parentKey,
              path: oldDir.path,
              dirty: oldDir.dirty,
              flat: false,
              mtime: oldDir.mtime,
              mode: oldDir.mode
            }, options);
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 3;
            _iterator = _asyncIterator(oldDir.eachChildSeries());

          case 5:
            _context2.next = 7;
            return _iterator.next();

          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 14;
              break;
            }

            _step$value = _step.value, key = _step$value.key, child = _step$value.child;
            _context2.next = 11;
            return newDir.put(key, child);

          case 11:
            _iteratorAbruptCompletion = false;
            _context2.next = 5;
            break;

          case 14:
            _context2.next = 20;
            break;

          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 20:
            _context2.prev = 20;
            _context2.prev = 21;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 25;
              break;
            }

            _context2.next = 25;
            return _iterator.return();

          case 25:
            _context2.prev = 25;

            if (!_didIteratorError) {
              _context2.next = 28;
              break;
            }

            throw _iteratorError;

          case 28:
            return _context2.finish(25);

          case 29:
            return _context2.finish(20);

          case 30:
            return _context2.abrupt("return", newDir);

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 16, 20, 30], [21,, 25, 29]]);
  }));
  return _convertToShard.apply(this, arguments);
}

module.exports = flatToShard;